module.exports = "<div class=\"tree-chart-wrapper\" #d3PieChartRef></div>\r\n\r\n<button class=\"randomize\">randomize</button>"